export type Route =
  | { name: "hub" }
  | { name: "game"; gameId: string };

export function parseHash(): Route {
  const h = (location.hash || "").replace("#", "").trim();
  if (!h) return { name: "hub" };

  const [name, id] = h.split("/");
  if (name === "game" && id) return { name: "game", gameId: id };

  return { name: "hub" };
}

export function goHub() {
  location.hash = "";
}

export function goGame(gameId: string) {
  location.hash = `game/${gameId}`;
}
